<template>
  <div class="menuBody"  style="padding-left:25px;">
        <BillAllocationDialog :param="diaLogData" ref="BillAllocationDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
             <div class="PageTabs">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="定额票据列表" name="first">定额票据列表</el-tab-pane>
                <el-tab-pane label="已分配票据列表" name="second">已分配票据列表</el-tab-pane>
              </el-tabs>
            </div>
             <div style="width:150px;float:left;margin-right:15px">
                    <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
                        <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
                    </el-select>
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入票据本编号" size="small" @blur="BillNum()"   v-model="BillNumber"></el-input>
              </div>
               <div style="width:220px;float:left;margin-right:15px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="DateTime"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div>
              <div style="width:120px;float:left;margin-right:5px">
                 <el-input placeholder="起始票据号码" size="small"  @blur="BillStart()"  v-model="BillStartNum"></el-input>
              </div>
               <div style="float:left;line-height: 30px;margin-right:5px">
                 -- 
              </div>
              <div style="width:120px;float:left;margin-right:15px">
                 <el-input placeholder="终止票据号码" size="small" @blur="BillEnd()"  v-model="BillEndNum"></el-input>
              </div>
             <div style="float:left;">
                <el-button type="primary" size="small" plain style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bm:ba:list'" @click="Inquire()">查询</el-button>
            </div>
              <el-table  :data="tableData"  tooltip-effect="light"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  @selection-change="ChangeBill"  v-loading="loading"  style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column type="selection" width="55px"></el-table-column>
    <el-table-column show-overflow-tooltip prop="typeName" label="票据类型" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="groupNo" label="票据本编号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="everyNums" label="份数"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="startEnd" label="票据号码范围"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="inDate" label="入库时间"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注" ></el-table-column>
  </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import BillAllocationDialog from "../common/BillAllocationDialog";
// import BillManTree from "../common/BillManTree.vue";
export default {
  name: "BillAllocationAlready",
  components: {BillAllocationDialog},
  data() {
    return {
      activeName:"second",
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillNumber:"",
        BillStartNum:"",
        BillEndNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      mangroupId:"",
      BillListo:"",
      BillTypeList:"",
      BillTypevalue:"",
      DateTime:"",
      BilltypeName:"",
    }
  },
       watch: {
    //   // 监听路由变化
     "$route.path": function(newVal, oldVal) {
       if(`${newVal}` == "/charge/distribution/list"){
       this.activeName = "first"
       }else if(`${newVal}` == "/charge/BillAllocationAlready"){
        this.activeName = "second"
       }
     }
  },
  methods: {
       handleClick(tab, event) {
        if(this.activeName == "first"){
          this.activeName = "first"
          this.$router.push({name: 'BillAllocation'})
        }else if(this.activeName == "second"){
          this.activeName = "second"
          this.$router.push({name: 'BillAllocationAlready'})
        }
      },
      ChangeBill(val){
      },
    ShareList(){
          let PageSize = {
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
            "isDistr":"1",
            "isFixed":"1",
      }
        this.$http.post(this.$requestUrl.POST_ALLOCATION_LIST,PageSize).then((res) => {
          let data = res.data;
          let arr = []
          if (200 === data.code) {
            this.total = data.data.total
            for(let val of data.data.records){
                val.startEnd = val.startNum + "--" + val.endNum
                arr.push(val)
            }
            this.loading = false
            this.tableData = arr;
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    ChargeBillType(){
      for(let val of this.BillTypeList){
        if(val.BillTypevalue == this.BillTypevalue){
          this.BilltypeName = val.BillTypelabel
        }
      }
    },
    handleSizeChange(val) {
        this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    Inquire(){
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "typeId":this.BillTypevalue,
        "startNum":this.BillStartNum,
        "endNum":this.BillEndNum,
        "groupNo":this.BillNumber,
        "isDistr":"1",
        "isFixed":"1"
      }
        this.$http.post(this.$requestUrl.POST_ALLOCATION_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    PropertyAdd(){
        this.getDate()
            this.$refs.BillAllocationDialog.title = "票据分配";
            this.$refs.BillAllocationDialog.titleone = "批量";
            this.$refs.BillAllocationDialog.dialogVisible = true; 
            this.$refs.BillAllocationDialog.BillTypeList = this.BillTypeList
            this.$refs.BillAllocationDialog.BillDateTime = this.time;
          let obj = {
            "BillCopies":"领用本数",
            "StorageDate":"领用时间",
            "remarks":"备注信息",
            "BillType":"票据管理组",
          }
          let row = {}
          row.obj = obj
          row.BillCopiest = "1"
          // console.log(row)
         this.$refs.BillAllocationDialog.formLabelAlign = row;
    },
    getDate(){
	    	let date = new Date();
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
            this.time = time
	    },
      // POST_BILLLIST_TYPE
      BillType(){
         this.$http.get(this.$requestUrl.POST_BILLLIST_TYPE).then((res)=>{
          let arr = []
          let date = res.data.data
          for(let val of date){
            let obj = {
              "BillTypevalue":val.typeNum,
              "BillTypelabel":val.name,
            }
            arr.push(obj)
          }
          this.BillTypeList = arr
        })
      },
      BillDateTime(){
          var d = this.DateTime[0];
          var datetime=d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
          var done = this.DateTime[1]
          var datetimeone=done.getFullYear() + '/' + (done.getMonth() + 1) + '/' + done.getDate();
          let obj = {
            "startInDate":datetime,
            "endInDate":datetimeone,
          }
      },
      BillNum(){
      },
      BillStart(){
      },
      BillEnd(){
      }

  },
  mounted() {
    this.ShareList()
    this.BillType()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.PageTabs{
  width: 100%;
  margin-bottom: 20px;
  .el-tabs__nav-scroll{
    border:none
  }
}
.el-tabs__content{
  display: none;
}
</style>